// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_areas_loyalty-dashboard_loyalty-dashboard_module_ts":"cc316a57919b138a","node_modules_echarts_index_js":"239e89617fefede1"}[chunkId] + ".js";
};